import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FIREBASE_MESSAGING } from '@core/providers/firebase.providers';
import { environment } from '@env/environment';
import { NotificationSnackBarComponent } from '@shared/snack-bars/notification-snack-bar/notification-snack-bar.component';
import {
  getToken,
  onMessage,
  onRegistered,
  register,
} from 'firebase/messaging';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private messaging = inject(FIREBASE_MESSAGING);
  private snackBar = inject(MatSnackBar);

  async getDeviceToken(): Promise<string | null> {
    try {
      // 1. Pedimos permisos de forma explícita
      console.log('Requesting permission...');
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        console.log('Notification permission denied.');
        return null;
      }

      console.log('Notification permission granted.');

      // return new Promise((resolve) => {
      //   const unsubscribe = onRegistered(this.messaging, (fid) => {
      //     resolve(fid);
      //   });

      //   register(this.messaging, { vapidKey: environment.VAPID_KEY }).catch(
      //     (err) => {
      //       console.error('Error durante el registro FCM', err);
      //       unsubscribe();
      //       resolve(null);
      //     },
      //   );
      // });
      if (this.messaging == null) {
        return null;
      }

      const token = await getToken(this.messaging, {
        vapidKey: environment.VAPID_KEY,
      });
      return token;
    } catch (error) {
      console.error('Error al procesar FCM', error);
      return null;
    }
  }

  listenToForegroundMessages() {
    if (this.messaging != null) {
      onMessage(this.messaging, (payload) => {
        console.log('Mensaje en primer plano: ', payload);

        this.snackBar.openFromComponent(NotificationSnackBarComponent, {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'top',
          data: payload,
        });
      });
    }
  }
}
